import React, { FC, useState } from 'react';
import styles from './CacheModal.module.css';
import { useAppDispatch } from '../../hooks/redux';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import CencelHeaderButton from '../Buttons/cencelHeaderButton/CencelHeaderButton';
import CustomInput from '../customInput/CustomInput';
import CustomButton from '../Buttons/customButton/CustomButton';
import ReactDOM from 'react-dom';
import { clearAllCache, clearCache } from '../../service/MetersService';
import { setErrorApp, setInfoApp } from '../../store/reducers/InfoSlice';

type CacheModalProps = {
	open: boolean,
	setClose: (value: boolean) => void,
};

type ValidPhoneType = 'root' | 'disabled' | 'error' | 'success';

const CacheModal: FC<CacheModalProps> = ({ open, setClose }) => {
	const [validPhone, setValidPhone] = useState<ValidPhoneType>('root');
	const [phone, setPhone] = React.useState<string>('');

	const dispatch = useAppDispatch();

	const closeModal = () => {
		setClose(false);
		setPhone('');
		setValidPhone('root');
	};

	const changePhoneValue = (value: string) => {
		const handlePhone = value
			.replace(/\(/g, '')
			.replace(/ /g, '')
			.replace(/\)/g, '')
			.replace(/-/g, '')
			.trim();
		if (handlePhone.length < 13 && /^\d+$/.test(handlePhone)) {
			if (handlePhone.length && handlePhone.length < 3) {
				setPhone(handlePhone);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length === 3) {
				setPhone(`${handlePhone.slice(0, 1)} (${handlePhone.slice(1, 3)}`);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length < 5) {
				setPhone(`${handlePhone.slice(0, 1)} (${handlePhone.slice(1, 4)}`);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length === 5) {
				setPhone(
					`${handlePhone.slice(0, 1)} (${handlePhone.slice(
						1,
						4
					)}) ${handlePhone.slice(4, 5)}`
				);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length < 8) {
				setPhone(
					`${handlePhone.slice(0, 1)} (${handlePhone.slice(
						1,
						4
					)}) ${handlePhone.slice(4, 7)}`
				);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length === 8) {
				setPhone(
					`${handlePhone.slice(0, 1)} (${handlePhone.slice(
						1,
						4
					)}) ${handlePhone.slice(4, 7)}-${handlePhone.slice(7, 8)}`
				);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length < 10) {
				setPhone(
					`${handlePhone.slice(0, 1)} (${handlePhone.slice(
						1,
						4
					)}) ${handlePhone.slice(4, 7)}-${handlePhone.slice(7, 9)}`
				);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length === 10) {
				setPhone(
					`${handlePhone.slice(0, 1)} (${handlePhone.slice(
						1,
						4
					)}) ${handlePhone.slice(4, 7)}-${handlePhone.slice(
						7,
						9
					)}-${handlePhone.slice(9, 11)}`
				);
				setValidPhone('error');
			} else if (handlePhone.length && handlePhone.length < 12) {
				setPhone(
					`${handlePhone.slice(0, 1)} (${handlePhone.slice(
						1,
						4
					)}) ${handlePhone.slice(4, 7)}-${handlePhone.slice(
						7,
						9
					)}-${handlePhone.slice(9, 11)}`
				);
				setValidPhone('success');
			}
		} else if (!handlePhone.length) {
			setPhone(handlePhone);
			setValidPhone('error');
		}
	};


	const deleteAllCacheNumber = async () => {
		const response = await clearAllCache();
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при удалении из кеша',
				})
			);
		} else {
			dispatch(
				setInfoApp({ isInfoApp: true, infoApp: 'Номера успешно удалены из кеша' })
			);
			setClose(false);
		}
	};

	const deleteCacheNumber = async (number: string) => {
		const response = await clearCache(number);
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при удалении из кеша',
				})
			);
		} else {
			dispatch(
				setInfoApp({ isInfoApp: true, infoApp: 'Номер успешно удален из кеша' })
			);
			setClose(false);
		}
	};

	const phoneNumber = (number: string) => {
		return number.
			replace(/\(/g, '')
			.replace(/ /g, '')
			.replace(/\)/g, '')
			.replace(/-/g, '')
	}

	const node = document.querySelector('#cache_modal');
	if (!node) return null;

	return ReactDOM.createPortal(
		<Modal
			open={open}
			onClose={closeModal}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<div className={styles.cache_card}>
				<div className={styles.cache_card__body}>
					<>
						<h2>Удаление номера из кеша</h2>
						<div className={styles.cache_card__form}>
							<span className={styles.cache_card__form_label}>
								Введите номер телефона:
							</span>
							<CustomInput
								mode={validPhone}
								placeholder="Номер телефона..."
								value={phone}
								changeInput={changePhoneValue}
								errorMessage={''}
							/>
							<div className={styles.cache_card__form_buttons}>
								<div className={styles.cache_card__form_buttons_container}>
									<CencelHeaderButton
										className={styles.close_balance}
										disabled={false}
										text={'Отмена'}
										onClick={closeModal}
									/>
									<CustomButton
										className={styles.activate_balance}
										disabled={false}
										text={'Удалить'}
										onClick={() => deleteCacheNumber(phoneNumber(phone))}
										disabledActivateButton={validPhone !== 'success'}
									/>
									<CustomButton
										className={styles.activate_balance}
										disabled={false}
										text={'Удалить все'}
										onClick={deleteAllCacheNumber}
										disabledActivateButton={false}
									/>
								</div>
							</div>
						</div>
					</>
				</div>
				<CloseIcon className={styles.close_button} onClick={closeModal} />
			</div>
		</Modal>,
		node
	);
};

export default CacheModal;
